import { useEffect } from "react";
import { Actions } from "../api/Actions";
import Api from "../api/Api";
import ApiCache from "../api/ApiCache";
import { Endpoints } from "./../api/Endpoints";

export default function ScheduledTasksTicker() {
  const delay =
    process.env.NODE_ENV === "development"
      ? 60 * 1000 // 1 min
      : 5 * 60 * 1000; // 5 min

  const tick = async () => {
    const result = await Api.Post(Endpoints.actions, {
      action: Actions.checkScheduledTasks,
    });
    if (result.success)
      ApiCache.invalidateRoutes(
        Endpoints.pendingBuyerValidations,
        Endpoints.pendingOptionValidations,
        Endpoints.pendingReservationValidations,
        `${Endpoints.programs}/*`,
        `${Endpoints.housings}/*`,
        `${Endpoints.buyers}/*`,
        `${Endpoints.mandates}/*`,
        `${Endpoints.users}/*`
      );
  };

  useEffect(() => {
    tick();
    const intervalId = setInterval(tick, delay);
    return () => clearInterval(intervalId);
  });

  return null;
}
